<template>
    <div class="details">
      <div class="details_part1">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">大赛简介</p>
          <p :class="'part_eng'+skinNum">Introduction of competition</p>
        </div>
        <div class="details_part1_mess">
          <p class="vHtmlMess" v-html="form.content" v-if="form.content!=null&&form.content!=''"></p>
          <img :src="form.activityUrl" alt="" v-if="form.activityUrl!=null&&form.activityUrl!=''">
          <!--<video :src="form.activityVideoUrl" class="part1_video" v-if="form.activityVideoUrl!=''"></video>-->
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions" v-if="form.activityVideoUrl!=''&&form.activityVideoUrl!=null"></video-player>
        </div>
      </div>
      <div class="details_part2">
         <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">组织机构</p>
          <p :class="'part_eng'+skinNum">The institution</p>
        </div>
        <div class="part2_mess">
          <p v-if="organizationList.length>0" v-for="(item,index) in organizationList" :key="index">
            <!-- {{ item.organizationName }} -->
			<span>
				{{ item.organizationName }}
			</span>
            <span>{{ item.organizationContent }}</span>
          </p>
          <!--<p v-if="form.sponsorName!=null&&form.sponsorName!=''">
            主办方
            <span>{{ form.sponsorName }}</span>
          </p>
          <p v-if="form.undertakerName!=null&&form.undertakerName!=''">
            承办方
            <span>{{ form.undertakerName }}</span>
          </p>
          <p v-if="form.jointlyName!=null&&form.jointlyName!=''">
            协办方
            <span>{{ form.jointlyName }}</span>
          </p>-->
          <div class="con_part2" v-if="logoList.length>0">
            <p>合作方</p>
            <div class="con_part2box">
              <img :src="item.url" alt="" v-for="(item,index) in logoList" :key="index">
            </div>
          </div>
        </div>
      </div>
      <div class="details_part3" v-if="wayList.length>0">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">奖项设置</p>
          <p :class="'part_eng'+skinNum">Award setting</p>
        </div>
        <!--<carousel-box :awardList='wayList'></carousel-box>-->
        <div class="details_part" style="margin-top: 36px;"
             v-for="(item,index) in wayList" :key="index"
             v-if="wayList.length>0">
          <div class="wayBack">
            <div class="wayBack_box" style="margin-right:20px">
              <i :class="'wayBack_box_line'+skinNum"></i>
              <i :class="'wayBack_box_round'+skinNum"></i>
            </div>
            <div>
              <p :class="'wayCss' + skinNum"> 赛道{{ numberFilter(index+1) }}</p>
              <p :class="'wayCss' + skinNum"> {{ item.name }} </p>              
            </div>
            <div class="wayBack_box" style="margin-left:20px">
              <i :class="'wayBack_box_round'+skinNum"></i>
              <i :class="'wayBack_box_line'+skinNum"></i>
            </div>
          </div>
          <carousel-box :awardList='item.awardList' :awardIndex="index + 1"></carousel-box>
        </div>
      </div>
      <div class="details_part4" v-if="nodeList.length==4||nodeList.lenth<4">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">活动时间</p>
          <p :class="'part_eng'+skinNum">The activity time</p>
        </div>
        <div class="part4_time">
          <img src="../../../assets/activelistImg/liu.png" alt="" class="part4_time_img">
          <div :class="'part4_time_date part4_time_date_mess'+(index+1)"
               v-for="(item,index) in nodeList"
               :key="index"
               v-if="nodeList.length>0">
            <p :class="'part4_time_date1' +skinNum">{{ item.name }}</p>
            <p :class="'part4_time_date2' +skinNum ">{{ getDateYear(item.startDate) }}</p>
            <p :class="'part4_time_date3'+skinNum " v-if="item.dateType==='DATE'">{{ getDateMonth(item.startDate) }}</p>
            <p :class="'part4_time_date3'+skinNum " v-if="item.dateType==='RANGE'">
              <span>{{ getDateMonth(item.startDate) }}</span>
              <i class="el-icon-caret-right"></i>
              <span>{{ getDateMonth(item.endDate) }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="details_parts" v-if="nodeList.length==5">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">活动时间</p>
          <p :class="'part_eng'+skinNum">The activity time</p>
        </div>
        <div class="part4_time">
          <img src="../../../assets/activelistImg/line.png" alt="" class="part4_time_img">
          <div :class="'part4_time_date part4_time_date_mess'+(index+1)"
               v-for="(item,index) in nodeList"
               :key="index"
               v-if="nodeList.length>0">
            <p class="part4_time_date1">{{ item.name }}</p>
            <p class="part4_time_date2">{{ getDateYear(item.startDate) }}</p>
            <p class="part4_time_date3" v-if="item.dateType==='DATE'">{{ getDateMonth(item.startDate) }}</p>
            <p class="part4_time_date3" v-if="item.dateType==='RANGE'">
              <span>{{ getDateMonth(item.startDate) }}</span>
              <i class="el-icon-caret-right"></i>
              <span>{{ getDateMonth(item.endDate) }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="details_part5 clearfix" v-if="form.entryDemand!=null&&form.entryDemand!=''">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">参赛要求</p>
          <p :class="'part_eng'+skinNum">Entry requirements</p>
        </div>
        <div class="part5_mess vHtmlMess" v-html="form.entryDemand">
          <!-- <p v-html="form.entryDemand"></p> -->
        </div>
      </div>
      <div class="details_part6" v-if="form.entryRule!=null&&form.entryRule!=''">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">参赛规则</p>
          <p :class="'part_eng'+skinNum">The rules</p>
        </div>
        <div class="part6_mess">
          <div class="part6_mess_box">
            <p v-html="form.entryRule" class="vHtmlMess"></p>
          </div>
        </div>
      </div>
      <div class="details_part7" v-show="fileList.length > 0 || form.fileContent">
        <div class="details_part">
          <p :class="'part'+skinNum">PART</p>
          <p :class="'part_tit'+skinNum">相关资料</p>
          <p :class="'part_eng'+skinNum">The relevant data</p>
        </div>
        <div class="part7_mess">
          <div class="part7_mes_box vHtmlMess" v-html="form.fileContent" v-if="form.fileContent!=null&&form.fileContent!=''"></div>
          <div class="part7_button" v-if="fileList.length>0">
            <p v-for="(item,index) in form.fileList" :key="index" @click="downloadFile(item.url,item.name)">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { getActivityDetailInfo } from '../../../utils/interface';
import carouselBox from './carouselBox';

export default {
  name:"activeDetailsRefs",
  data(){
    return {
      form:{},
      logoList:[],
      awardList:[],
      fileList:[],
      nodeList:[],
      wayList:[],
      organizationList:[],
      styleName:"",
      skinNum:0,
      playerOptions : {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false  //全屏按钮
        },
      },
    }
  },
  components:{
    carouselBox
  },
  mounted(){

  },
  methods: {
    numberFilter (num) {
      const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // changeNum[0] = "零"
      const unit = ['', '十', '百']
      num = parseInt(num)
      const getWan = (temp) => {
        const strArr = temp.toString().split('').reverse()
        let newNum = ''
        for (let i = 0; i < strArr.length; i++) {
          newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
        }
        return newNum
      }
      const overWan = Math.floor(num / 100)
      let noWan = num % 100
      if (noWan.toString().length < 2) noWan = '0' + noWan
      let strr = (overWan ? getWan(overWan) + '百' + getWan(noWan) : getWan(num))
      if(strr.split('')[0] == '一'){
        let showNum = "";
        if(strr == '一'){
          showNum = strr.substring(0);
        }else{
          showNum = strr.substring(1);
        }
        return showNum
      }else{
        let showNum = overWan ? getWan(overWan) + '百' + getWan(noWan) : getWan(num);
        return showNum
      }
    },
    init(uuid) {
      this.form = {};
      getActivityDetailInfo({uuid:uuid}).then((res)=>{
        this.form = res;
        this.logoList = res.logoList;
        this.nodeList = res.nodeList;
        this.wayList = res.wayList;
        this.organizationList = res.organizationList;
        this.styleName = res.styleName;
        if(this.styleName == "蓝色版"){
          this.skinNum = 0;
        } else if(this.styleName == "紫色版"){
          this.skinNum = 1;
        } else if(this.styleName == "绿色版"){
          this.skinNum = 2;
        }
        //this.awardList = res.awardList;
        this.fileList = res.fileList;
        if(this.form.activityVideoUrl!=''){
          this.playerOptions.sources[0].src = this.form.activityVideoUrl;
        }
      });
    },
    getDateYear(value){
      let date = new Date(value);
      let y = date.getFullYear();
      return y;
    },
    getDateMonth(value){
      let date = new Date(value);
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return MM + "." + d;
    },
    downloadFile(fileUrl,name){
      const x = new window.XMLHttpRequest();
      x.open('GET', fileUrl, true);
      x.responseType = 'blob';
      x.onload = () => {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.click();
      };
      x.send();
    },

    // downloadFile(fileUrl,name){
    //   this.download()
    //   // const blob = new Blob([fileUrl])
    //   // let a = document.createElement('a');
    //   // a.href = URL.createObjectURL(blob);
    //   // // a.download = filename;
    //   // a.click();
    // },
  },
}
</script>
<style scoped lang="less">
.details {
  width: 1200px;
  background: rgba(255, 255, 255);
  box-shadow: 0px 0px 10px rgba(137, 190, 253, 0.49);
  border-radius: 20px;
  margin: 25px auto 51px;
  padding: 44px 70px 20px;
  box-sizing: border-box;
  .details_part {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    text-align: center;
    //color: #1C7EF3;
    .part0{
      color: #1C7EF3;
    }
    .part1{
      color: #B0B1E5;
    }
    .part2{
      color: #61B45C;
    }
    .part_tit0 {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #1C7EF3;
      margin: 4px 0;
    }
    .part_tit1 {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #B0B1E5;
      margin: 4px 0;
    }
    .part_tit2 {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #61B45C;
      margin: 4px 0;
    }
    .part_eng0 {
      font-size: 12px;
      font-family: PingFang SC;
      color: #1C7EF3;
      opacity: 0.32;
    }
    .part_eng1 {
      font-size: 12px;
      font-family: PingFang SC;
      color: #B0B1E5;
      opacity: 0.32;
    }
    .part_eng2 {
      font-size: 12px;
      font-family: PingFang SC;
      color: #61B45C;
      opacity: 0.32;
    }
  }
  .details_part1 {
    // text-align: center;
    .details_part1_mess {
      font-size: 14px;
      line-height: 28px;
      p {
        margin: 28px 0;
      }
      /deep/img {
        max-width: 100%;
      }
    }
    .part1_video {
      width: 961px;
      height: 486px;
      background: rgba(243, 243, 243, 0.39);
      border-radius: 10px;;
    }
  }
  .details_part2 {
    margin: 93px 0 83px;
    .part2_mess {
      font-size: 14px;
      p {
        display: flex;
        align-items: center;
        color: #646464;
        margin-bottom: 8px;
        flex-shrink: 0;
		span:first-child{
			color: #646464;
			margin-left: 8px;
			display: inline-block;
			min-width: 60px;
		}
        span {
          color: #099;
          margin-left: 8px;
        }
      }
      .con_part2 {
        margin-top: 27px;
        display: flex;
        // align-items: center;
        color: #646464;
        margin-bottom: 8px;
        flex-shrink: 0;

        .con_part2box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        img {
            width: 190px;
            height: 90px;
            margin-right: 20px;
            margin-left: 8px;
            margin-bottom: 10px;
          }
        }
        p {
			min-width: 60px;
          align-items: flex-start;
          // margin-top: 10px;
		  font-weight: bold;
		      margin-left: 8px;
			  line-height: 90px;
        }

      }
    }
  }
  .details_part3 {
    margin-bottom: 100px;
    .part3_mess {
      padding-top: 62px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      overflow-x: auto;
      /*定义滚动条样式*/
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background: rgba(240,240,240,1);
      }
　　   /*定义滚动条轨道内阴影+圆角*/
      ::-webkit-scrollbar-track {
        box-shadow: inset000pxrgba(240,240,240,.5);
        border-radius: 10px;
        background: rgba(240,240,240,.5);
      }
  　　/*定义滑块内阴影+圆角*/
      ::-webkit-slider-thumb {
        border-radius: 10px;
        box-shadow: inset000pxrgba(240,240,240,.5);
        background: rgba(240,240,240,.5);
      }
    }
    .part3_mess_pre {
      position: relative;
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      width: 249px;
      height: 307px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      margin-right: 115px;
      flex-shrink: 0;
      &:nth-last-of-type(1){
        margin-right: 0;
      }
      .pre_part3_tit {
        width: 137px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
      }
      img {
        width: 120px;
        height: 154px;
        position: absolute;
        bottom: 8px;
        right: -17px;
      }
    }
    .part3_mess_pre:nth-of-type(2)  {
      position: relative;
      font-size: 22px;
      font-weight: bold;
      color: #000000;
      width: 306px;
      height: 378px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      .pre_part3_tit {
        width: 168px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
        font-size: 21px;
      }
      img {
        width: 396px;
        height: 133px;
        position: absolute;
        bottom: 8px;
        right: -78px;
      }
    }
  }
  .details_part4 {
    margin-bottom: 219px;
    .part4_time {
      position: relative;
      margin-top: 176px;
      .part4_time_img {
        width: 100%;
      }
      .part4_time_date {
        position: absolute;
        top: -110px;
        left: 0;
        .part4_time_date10 {
          width: 120px;
          height: 40px;
          background: rgba(21, 126, 251);
          border-radius: 20px;
          font-size: 16px;    
          color: #fff;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date11 {
          width: 120px;
          height: 40px;
          background: #B0B1E5;
          border-radius: 20px;
          font-size: 16px;    
          color: #fff;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date12 {
          width: 120px;
          height: 40px;
          background: #61B45C;
          border-radius: 20px;
          font-size: 16px;    
          color: #fff;   
          line-height: 40px;
          text-align: center;
        }
        
        .part4_time_date2 {
          font-size: 16px;
          margin: 3px 0;
        }
        .part4_time_date3 {
          font-size: 24px;
          font-weight: bold;
          display: flex;
        }
      }
      .part4_time_date_mess2 {
        top: 31px;
        left: 27%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess3 {
        left: 56%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess4 {
        top: 31px;
        left: 87%;
      }

    }
  }
   .details_parts {
    margin-bottom: 219px;
    .part4_time {
      position: relative;
      margin-top: 176px;
      .part4_time_img {
        width: 100%;
      }
      .part4_time_date {
        position: absolute;
        top: -110px;
        left: 0;
        .part4_time_date1 {
          width: 120px;
          height: 40px;
          background: rgba(21, 126, 251);
          border-radius: 20px;
          font-size: 16px;    
          color: #fff;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date2 {
          font-size: 16px;
          margin: 3px 0;
        }
        .part4_time_date3 {
          font-size: 24px;
          font-weight: bold;
          display: flex;
        }
      }
      .part4_time_date_mess2 {
        top: 31px;
        left: 21%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess3 {
        left: 46%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess4 {
        top: 31px;
        left: 70%;
      }
      .part4_time_date_mess5 {
        // top: 31px;
        left: 91%;
      }
    }
  }
  .details_part5 {
    margin-bottom: 100px;
    .part5_mess {
      margin-top: 19px;
      /deep/img {
        max-width: 100%;
      }
      
      // font-size: 14px;
      // color: #646464;
      // line-height: 28px;
    }
  }
  .clearfix::after{
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
  .details_part6 {
    margin-bottom: 100px;
    .part6_mess {
      margin-top: 25px;
      .part6_mess_box {
        /deep/img {
          max-width: 100%;
        }
        // font-size: 14px;
        // line-height: 28px;
        // color: #646464;
        &:nth-of-type(1){
          margin-bottom: 30px;
        }
      }
    }
  }
  .details_part7 {
    .part7_mess {
      .part7_mes_box {
        margin: 32px 0 20px;
        /deep/img {
          max-width: 100%;
        }
      }
      .part7_button {
        // display: flex;
        // align-items: center;
        cursor: pointer;
        .part7_button_icon {
          width: 40px;
          height: 40px;
          background: rgba(245, 245, 245, 0.39);
          border-radius: 12px;
          color: #1C7EF3;
          text-align: center;
          line-height: 40px;
          i {
            font-size: 30px;
            color: #1C7EF3;
          }
        }
        p {
          font-size: 14px;
          color: #1C7EF3;
          margin-bottom: 9px;
        }
      }
    }
  }
  .wayBack{
    display: flex;
    align-items: center;
    justify-content: center;
    .wayBack_box {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
      }
      .wayBack_box_line0 {
        width: 74px;
        height: 2px;
        background: #1C7EF3;
      }
      .wayBack_box_line1 {
        width: 74px;
        height: 2px;
        background: #B0B1E5;
      }
      .wayBack_box_line2 {
        width: 74px;
        height: 2px;
        background: #61B45C;
      }
      .wayBack_box_round0 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #1C7EF3;
      }
       .wayBack_box_round1 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #B0B1E5;
      }
       .wayBack_box_round2 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #61B45C;
      }
    }
  }
  .wayCss0{
    margin: 4px 0;
    font-size: 18px;
    color: #1C7EF3;
    font-size: 16px;
    font-weight: normal;
  }
  .wayCss1{
    margin: 4px 0;
    font-size: 18px;
    color: #B0B1E5;
    font-size: 16px;
    font-weight: normal;
  }
  .wayCss2{
    margin: 4px 0;
    font-size: 18px;
    color: #61B45C;
    font-size: 16px;
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeZhuDetail.vue